<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(item.value)">
        <span
          v-if="item.raw.listClass == 'default' || item.raw.listClass == ''"
          :key="item.value"
          :index="index"
          :class="item.raw.cssClass"
        >
          {{ translate(item.label) }}
        </span>
        <a-badge
          v-else
          :key="item.value"
          :index="index"
          :status="item.raw.listClass|statusFilter"
          :class="item.raw.cssClass"
          :text="translate(item.label)"
        >
        </a-badge>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DictTag',
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: [Number, String, Array],
      default: null
    }
  },
  computed: {
    values () {
      console.log(this.options,this.value)
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [String(this.value)]
      } else {
        return []
      }
    }
  },
  methods: {
    // 将中文字典标签翻译为英文显示
    translate(label) {
      if (!label) return ''
      const map = {
        // user_cancel_status
        '待审核': 'Pending Review',
        '审核通过': 'Approved',
        '审核成功': 'Approved',
        '审核拒绝': 'Rejected',
        '审核失败': 'Rejected',
        // sys_normal_disable
        '正常': 'Normal',
        '停用': 'Disabled',
        // sys_enable_disable
        '启用': 'Enable',
        '禁用': 'Disable',
        // sys_show_hide
        '显示': 'Display',
        '隐藏': 'Hide',
        '是': 'Yes',
        '否': 'No'
      }

      const translated = this.$t(label)
      if (translated !== label) {
        return translated
      }
      return map[label] || label
    }
  },
  filters: {
    statusFilter(lclass) {
      let str = ''
      lclass == 'primary' || lclass == 'info' ? str = 'processing' :
      lclass == 'danger' ? str = 'error' : str = lclass
      return str
    }
  }
}
</script>
